import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import abtimg from "../images/home-about.jpeg"
import heroVideo from '../images/hero-video.mp4';
import tomatoTitle from '../images/tomoto-title.jpeg';
import chilliTitle from '../images/chilli-title.jpeg';
import brinjalTitle from '../images/brinjal-title.jpeg';
import watermelonTitle from '../images/watermelon-title.jpeg';
import muskmelonTitle from '../images/muskmelon-title.jpeg';
import bhendiTitle from '../images/bhendi-title.jpeg';
import pumpkinTitle from '../images/pumpkin-title.jpeg';
import cucumberTitle from '../images/cucumber-title.jpeg';

const homeProductTitleImages = {
  tomato: tomatoTitle,
  chilli: chilliTitle,
  brinjal: brinjalTitle,
  watermelon: watermelonTitle,
  muskmelon: muskmelonTitle,
  bhendi: bhendiTitle,
  pumpkin: pumpkinTitle,
  cucumber: cucumberTitle,
};

const capabilityCards = [
  {
    title: 'R&D Activities',
    icon: '🌱',
    text: 'Breeding support, trial observation, performance recording, and feedback loops.',
    link: '/r-and-d',
  },
  {
    title: 'Seed Production',
    icon: '🌿',
    text: 'Foundation and certified seed multiplication with close supervision and traceability.',
    link: '/seed-production',
  },
  {
    title: 'Seed Processing & Quality',
    icon: '🤲',
    text: 'Cleaning, treatment, grading, and final inspection for stronger seed confidence.',
    link: '/seed-processing-quality',
  },
];

const homeProducts = [
  { _id: 'tomato', name: 'Tomato', slug: 'tomato', image: homeProductTitleImages.tomato },
  { _id: 'chilli', name: 'Chilli', slug: 'chilli', image: homeProductTitleImages.chilli },
  { _id: 'brinjal', name: 'Brinjal', slug: 'brinjal', image: homeProductTitleImages.brinjal },
  { _id: 'watermelon', name: 'Watermelon', slug: 'watermelon', image: homeProductTitleImages.watermelon },
  { _id: 'muskmelon', name: 'Muskmelon', slug: 'muskmelon', image: homeProductTitleImages.muskmelon },
  { _id: 'bhendi', name: 'Bhendi', slug: 'bhendi', image: homeProductTitleImages.bhendi },
  { _id: 'pumpkin', name: 'Pumpkin', slug: 'pumpkin', image: homeProductTitleImages.pumpkin },
  { _id: 'cucumber', name: 'Cucumber', slug: 'cucumber', image: homeProductTitleImages.cucumber },
];

const testimonials = [
  {
    image: "https://images.pexels.com/photos/18620460/pexels-photo-18620460.jpeg",
    quote:
      'Dynasty Agri Seeds gave me a uniform stand and strong early growth. The crop looked healthier from the start, and the final yield gave me real confidence to sow the same line again.',
    name: 'Ramesh ',
  },
  {
    image: 'https://images.pexels.com/photos/11794491/pexels-photo-11794491.jpeg',
    quote:
      'What I liked most about Dynasty Agri Seeds was the consistency. The plants stayed vigorous, the crop matured evenly, and I could plan harvesting with much less stress.',
    name: 'Mahesh ',
  },
  {
    image: 'https://images.pexels.com/photos/20503431/pexels-photo-20503431.jpeg',
    quote:
      'After switching to Dynasty Agri Seeds, I saw better crop uniformity and a cleaner harvest. The quality was good enough to build trust with buyers and improve my returns.',
    name: 'Savitri ',
  },
  {
    image: 'https://images.pexels.com/photos/13061060/pexels-photo-13061060.jpeg',
    quote:
      'For me, Dynasty Agri Seeds means dependable performance in the field. Strong establishment, good fruit setting, and better finish helped me get the results I was aiming for.',
    name: 'Srinivasulu',
  },
];

const Home = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 4500);

    return () => window.clearInterval(timer);
  }, []);

  const handlePrevTestimonial = () => {
    setActiveTestimonial((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNextTestimonial = () => {
    setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const selectedTestimonial = testimonials[activeTestimonial];

  return (
    <div>
      <section className="hero hero-home">
        <video
          className="home-hero-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          aria-label="Dynasty Agri Seeds promotional video"
        >
          <source src={heroVideo} type="video/mp4" />
        </video>
      </section>

   

      <section className="container section-pad">
        <div className="service-grid">
          {capabilityCards.map((card) => (
            <Link to={card.link} className="service-card service-card-link" key={card.title}>
              <h3>{card.title}</h3>
              <p>{card.text}</p>
              <span className="know-more-btn">Know More &rarr;</span>
            </Link>
          ))}
        </div>
      </section>

      <section className="about-showcase-section">
        <div className="container about-showcase-grid">
          <div className="about-showcase-content">
            <p className="about-showcase-kicker">About</p>
            <h2>DYNASTY AGRI SEEDS</h2>
            <p>
              Dynasty Agri Seeds is a seed-focused company supporting growers with dependable crop genetics,
              disciplined production, and practical field performance. Our teams work from research through
              processing to ensure that each seed lot is selected with care, produced with supervision, and
              supplied on time to farming communities.
            </p>
            <p>
              Our objective is to deliver high-quality seeds that help farmers improve productivity and protect
              investment outcomes through consistency, traceability, and quality-first execution.
            </p>
          </div>

          <div className="about-showcase-media">
            <img
              src={abtimg}
              alt="Fresh tomatoes held by a farmer"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <section className="container section-pad">
        <div className="section-header">
          <h2>Our Products</h2>
        </div>
        <div className="products-intro-text">
          <p style={{ marginBottom: '1rem' }}>At Dynasty Agriseeds., every seed carries the promise of progress. Guided by our legacy, we develop superior vegetable hybrids that enrich lives, achieve higher productivity, and support a sustainable farming future.</p>
          <p>Our high-performing portfolio sets new benchmarks in yield, disease resistance, and quality. From climate-resilient genetics to practical knowledge support, each Dynasty Agriseeds hybrid is carefully designed to deliver consistent performance and dependable returns for progressive farmers.</p>
        </div>

        <div className="home-products-grid">
          {homeProducts.map((product) => (
            <ProductCard
              key={product._id}
              product={product}
              showDescription={false}
              centerTitle
              imageFit="cover"
              to={`/products/${product.slug}`}
            />
          ))}
        </div>

        <div className="home-products-action">
          <Link to="/products" className="view-all-btn">
            View All Products
          </Link>
        </div>
      </section>

      <section className="container section-pad">
        <div className="section-header">
          <h2>Testimonials</h2>
          <p>What farmers say about our seed performance and support.</p>
        </div>

        <div className="testimonials-carousel" role="region" aria-label="Farmer testimonials carousel">
          <button
            type="button"
            className="testimonial-nav testimonial-nav--prev"
            onClick={handlePrevTestimonial}
            aria-label="Previous testimonial"
          >
            ‹
          </button>

          <article className="testimonial-card testimonial-card--active" key={selectedTestimonial.name}>
            <div className="testimonial-media">
              <img src={selectedTestimonial.image} alt={selectedTestimonial.name} loading="lazy" />
            </div>

            <div className="testimonial-content">
              <p>{selectedTestimonial.quote}</p>
              <h4>Farmer</h4>
              <strong>{selectedTestimonial.name}</strong>
            </div>
          </article>

          <button
            type="button"
            className="testimonial-nav testimonial-nav--next"
            onClick={handleNextTestimonial}
            aria-label="Next testimonial"
          >
            ›
          </button>
        </div>

        <div className="testimonial-dots" aria-hidden="true">
          {testimonials.map((item, index) => (
            <button
              key={item.name}
              type="button"
              className={`testimonial-dot${activeTestimonial === index ? ' active' : ''}`}
              onClick={() => setActiveTestimonial(index)}
              aria-label={`Show testimonial ${index + 1}`}
            />
          ))}
        </div>
      </section>

      {/* <section className="home-contact-shell">
        <div className="container home-contact-grid">
          <div className="home-contact-content">
            <p className="home-contact-kicker">Get In Touch</p>
            <h2>Dynasty Agri Seeds</h2>

            <form className="home-contact-form" onSubmit={handleHomeContactSubmit}>
              <div className="home-contact-row">
                <input type="text" placeholder="Full Name" required />
                <input type="tel" placeholder="Phone No" required />
              </div>

              <div className="home-contact-row">
                <input type="email" placeholder="Email" required />
                <input type="text" placeholder="Subject" required />
              </div>

              <textarea placeholder="Message" rows={5} required></textarea>

              <button type="submit" className="home-contact-btn">
                Submit
              </button>
            </form>
          </div>

          <div className="home-contact-image-wrap">
            <img
              src={vegetablelogo}
              alt="Fresh vegetables"
              loading="lazy"
            />
          </div>
        </div>
      </section> */}

    

   
    </div>
  );
};

export default Home;
